// extracted by mini-css-extract-plugin
export var calendarView = "_ot-0";
export var dayButton = "_ot-1";
export var dayCircle = "_ot-2";